export default {
  'facility-selection.list-title': 'Bitte wählen Sie eine Einrichtung aus',
  'facility-selection.appointment-types': 'Termintypen',
  'facility-selection.appointment-types.group-appointment': 'Gruppentermin',
  'facility-selection.appointment-types.group-appointment-quota':
    'Gruppentermin (max {quota} Teilnehmer)',
  'facility-selection.no-appointment-types':
    'Es tut uns sehr leid. Wir führen aktuell Wartungsarbeiten durch.',
  'facility-selection.list-description':
    'Bitte wählen Sie eine Sprechstunde aus, um einen Termin zu buchen.',
  'facility-selection.list.facility-disabled':
    'Sie müssen Ihre E-Mail verifizieren bevor Sie weitere Termine in dieser Einrichtung buchen können.',
  'facility-selection.list-description.clinic':
    'Wählen Sie die gewünschte Einrichtung aus, für die Sie einen Termin buchen möchten.',
  'facility-selection.contact.title': '{facilityName} Kontakt',
  'facility-selection.contact.emergency':
    'Bitte kontaktieren Sie die Einrichtung telefonisch, falls es sich um einen Notfall handelt.',
  'facility-selection.contact.doctolib': 'Buchung über Doctolib',
  'facility-selection.opening-hours.title': 'Öffnungszeiten',
  'facility-selection.visiting-hours.title': 'Besuchszeiten',
  'facility-selection.closed': 'Geschlossen',
  'facility-selection.no-description': 'Keine weitere Beschreibung verfügbar',
  'facility-selection.next-available-appointments': 'Nächste verfügbare Termine',
  'facility-selection.no-next-available-appointments':
    'Für diese Einrichtung sind aktuell keine freien Termine mehr vorhanden',
  'facility-selection.no-data': 'Es wurden keine Einrichtungen zu Ihrem Suchbegriff gefunden',
  'facility-selection.select-type':
    'Bitte wählen Sie einen Termintyp und einen Terminort aus, um die nächsten verfügbaren Termine anzuzeigen.',
  'facility-selection.appointment-booking': 'Terminbuchung',
  'facility-selection.appointment-request': 'Terminanfrage',
  'facility-selection.appointment-request.request': 'Termin anfragen',

  'facility-selection.appointment-locations': 'Terminort',
  'facility-selection.appointment-locations.select-appointment-type':
    'Bitte wählen Sie einen Termintyp aus, um die verfügbaren Terminorte zu sehen.',

  'facility-details.contact': 'Kontakt',

  'facility-selection-help.title': 'Brauchen Sie Hilfe?',
  'facility-selection-help.text':
    'Um einen Termin zu buchen, wählen Sie bitte zunächst die gewünschte Einrichtung aus der Liste aus. Sie können nicht in allen Einrichtungen Termine direkt buchen. Wählen Sie in diesem Fall bitte die gewünschte Untereinrichtung aus.',

  'facility-selection.appointment-request.description':
    'Für diesen Termintyp ist eine Terminanfrage nötig. Sie werden nach Bearbeitung Ihrer Anfrage von der Klinik über die Termindetails informiert.',

  'facility-selection.slot-selection.description':
    'Für diesen Termintyp ist eine Bestätigung von Seiten der ausgewählten Einrichtung notwendig.',

  'facility-selection.frequently-asked-questions': 'Häufig gestellte Fragen',
};
